import { render } from "./galleryManager.vue?vue&type=template&id=118f003a&scoped=true&ts=true"
import script from "./galleryManager.vue?vue&type=script&lang=ts"
export * from "./galleryManager.vue?vue&type=script&lang=ts"

import "./galleryManager.vue?vue&type=style&index=0&id=118f003a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-118f003a"]])

export default __exports__